import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Drawer from 'material-ui/Drawer';
import IconButton from 'material-ui/IconButton';
import List, { ListItem, ListItemText } from 'material-ui/List';
import Divider from 'material-ui/Divider';
import Settings from 'material-ui-icons/Settings';
import { groupFilter } from '../../redux/sankeyColumnFilter';
import Checkbox from 'material-ui/Checkbox';
import Switch from 'material-ui/Switch';
import {
  NAV_SANKEY_OPTIONS_SHOW_COSTS,
  NAV_SANKEY_OPTIONS_SHOW_NAMES,
  NAV_SANKEY_OPTIONS_SHOW_VALUES
} from '../../constants/actionMessages';

const styles = {
  list: {
    width: 250,
    flex: 'initial'
  },
  listFull: {
    width: 'auto',
    flex: 'initial'
  }
};

class NavSankeyOptions extends Component {
  state = {
    open: {
      top: false,
      left: false,
      bottom: false,
      right: false
    }
  };

  toggleDrawer = (side, open) => {
    const drawerState = {};
    drawerState[side] = open;
    this.setState({ open: drawerState });
  };

  handleRightOpen = () => this.toggleDrawer('right', true);
  handleRightClose = () => this.toggleDrawer('right', false);
  handleColumnChange = selectedFilter =>
    this.props.setSankeyColumnFilter(selectedFilter);

  render() {
    const {
      classes,
      sankeyOptions,
      sankeyColumnFilter,
      costs,
      loading,
      setSankeyOptionsValues,
      setSankeyOptionsCosts,
      setSankeyOptionsNames
    } = this.props;
    const filterListItems = Object.keys(groupFilter).map((key, index) => (
      <ListItem key={key} button onClick={() => this.handleColumnChange(key)}>
        <Checkbox
          checked={sankeyColumnFilter.includes(key)}
          tabIndex="-1"
          disableRipple
        />
        <ListItemText primary={groupFilter[key].name} />
      </ListItem>
    ));

    const additionalSankeySettings = (
      <div>
        <ListItem button>
          <Switch
            onClick={event => setSankeyOptionsNames(!sankeyOptions.showNames)}
            checked={sankeyOptions.showNames}
          />
          <ListItemText primary={NAV_SANKEY_OPTIONS_SHOW_NAMES} />
        </ListItem>
        <ListItem button>
          <Switch
            onClick={event => setSankeyOptionsValues(!sankeyOptions.showValues)}
            checked={sankeyOptions.showValues}
          />
          <ListItemText primary={NAV_SANKEY_OPTIONS_SHOW_VALUES} />
        </ListItem>
        <ListItem button>
          <Switch
            onClick={event => setSankeyOptionsCosts(!sankeyOptions.showCosts)}
            checked={sankeyOptions.showCosts}
            disabled={!costs}
          />
          <ListItemText primary={NAV_SANKEY_OPTIONS_SHOW_COSTS} />
        </ListItem>
      </div>
    );

    const sideList = (
      <div>
        <List className={classes.list} disablePadding>
          {filterListItems}
        </List>
        <Divider />
        <List className={classes.list} disablePadding>
          {additionalSankeySettings}
        </List>
      </div>
    );

    return (
      <div>
        <IconButton disabled={loading} onClick={this.handleRightOpen}>
          <Settings />
        </IconButton>

        <Drawer
          anchor="right"
          open={this.state.open.right}
          onRequestClose={this.handleRightClose}
        >
          {sideList}
        </Drawer>
      </div>
    );
  }
}

NavSankeyOptions.propTypes = {
  classes: PropTypes.object.isRequired,
  loading: PropTypes.bool
};

export default withStyles(styles, { name: 'NavSankeyOptions' })(
  NavSankeyOptions
);



// WEBPACK FOOTER //
// ./src/components/nav/NavSankeyOptions.js